import { safetyPoints } from "@/mocks/home";

export default function SafetyNotice() {
  return (
    <section id="safety" className="bg-background-100 py-14 md:py-20 px-4 md:px-10">
      <div className="rounded-2xl bg-primary-900 px-5 py-8 md:px-10 md:py-12">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-accent-300 uppercase">
              <i className="ri-shield-star-line" />
              安全与信任
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 text-balance">
              认准地址，别让仿冒站替你「换地址」
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-background-200">
            越是频繁更换地址的站点，越容易被冒用。记住下面三条，基本就能避开绝大多数假入口。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4">
          {safetyPoints.map((point) => (
            <div
              key={point.title}
              className="rounded-lg bg-primary-950/40 border border-primary-800/60 p-5"
            >
              <span className="w-10 h-10 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className={`${point.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-base font-medium text-background-50">{point.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200">{point.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}